// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(max-width: 1024px){.card-tracking{margin-bottom:40px}}", "",{"version":3,"sources":["webpack://./src/components/DashboardV2/Cards/CardTracking.vue"],"names":[],"mappings":"AACA,0BACE,eACE,kBAAA,CAAA","sourcesContent":["\n@media (max-width: 1024px) {\n  .card-tracking {\n    margin-bottom: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
